import {
    BottomSheet as UIBottomSheet,
    ListItemButton as MuiListItemButton,
    styled,
    Typography,
} from "@l2r-front/l2r-ui"

export const ListItemButton = styled(MuiListItemButton, {
    shouldForwardProp: (prop) => prop !== "selected",
})(({ selected, theme }) => {

    const backgroundColor = selected ? "primary/_states/hover" : "common/white_states"

    return ({
        "&:hover": {
            backgroundColor: `${theme.palette["primary/_states/hover"].main} !important`,
        },
        backgroundColor: `${theme.palette[backgroundColor].main} !important`,
        border: `2px solid ${selected ? theme.palette["primary"].main : theme.palette["common/white_states"].main}`,
        borderRadius: 12,
        display: "flex",
        gap: theme.spacing(8),
        fontSize: selected ? theme.typography["Desktop & Mobile/Heading/H3"].fontSize : theme.typography["Desktop & Mobile/Body/Regular"].fontSize,
        fontWeight: selected ? theme.typography["Desktop & Mobile/Heading/H3"].fontWeight : theme.typography["Desktop & Mobile/Body/Regular"].fontWeight,
        height: "fit-content",
        padding: theme.spacing(2, 4),
        width: "100%",
    })
})

export const NetworkLabel = styled("div", {
    shouldForwardProp: (prop) => prop !== "variant",
})(({ theme, variant }) => ({
    alignSelf: "stretch",
    alignItems: "center",
    display: "flex",
    marginRight: "auto",
    fontWeight: theme.typography[variant].fontWeight,
}))

export const List = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignSelf: "stretch",
    padding: theme.spacing(0, 4),
}))

export const Text = styled(Typography)({
    textAlign: "center",
})

export const BottomSheet = styled(UIBottomSheet)(({ theme }) => ({
    zIndex: theme.zIndex["modal"] + 1,
}))
